import { useState } from 'react'

import { MediaObject } from '@definitions/types/symfonyTypesd'

const uploadFileByRequest = async (file: any): Promise<string> => {
  return new Promise(function (resolve, reject) {
    const apiEndpoint =
      (process.env.symfonyGraphQl ?? '').replace('/graphql', '') +
      '/media_objects'
    const request = new XMLHttpRequest()
    const formData = new FormData()

    request.open('POST', apiEndpoint, true)
    request.onreadystatechange = () => {
      if (request.readyState === 4) {
        if (request.status === 200 || request.status === 201) {
          resolve(request.responseText)
        } else {
          reject(`status: ${request.status}`)
        }
      }
    }
    formData.append('file', file)
    request.send(formData)
  })
}

interface useFileUploadReturnType {
  uploadFile: (file: any) => Promise<MediaObject | null>
  mediaObject: any | null
  errorUpload: string | null
  isUploading: boolean
  lastUploadedFile: any | null
  clearUpload: () => void
}

export default function useFileUpload(): useFileUploadReturnType {
  const [mediaObject, setMediaObject] = useState<any | null>(null)
  const [errorUpload, setErrorUpload] = useState<string | null>(null)
  const [isUploading, setIsUploading] = useState<boolean>(false)
  const [lastUploadedFile, setLastUploadedFile] = useState<any | null>(null)

  const clearUpload = () => {
    setMediaObject(null)
    setErrorUpload(null)
    setIsUploading(false)
    setLastUploadedFile(null)
  }

  const uploadFile = async (file: any): Promise<MediaObject | null> => {
    setIsUploading(true)

    try {
      const response = await uploadFileByRequest(file)

      const mediaObject: MediaObject | any = JSON.parse(response)
      mediaObject.id = mediaObject['@id']

      setMediaObject(mediaObject)
      setIsUploading(false)
      setLastUploadedFile(file)

      return mediaObject
    } catch (error: any) {
      console.error(error)
      setErrorUpload(error.message)
      setIsUploading(false)
    }

    return null
  }

  return {
    uploadFile,
    mediaObject,
    errorUpload,
    isUploading,
    lastUploadedFile,
    clearUpload,
  }
}
